export const PC_THRESHOLD_HEIGHT = 750;
export const M_THRESHOLD_RATIO = 1.78;

export const calculatePcImageSize = (pcWidth: number, naturalWidth?: number, naturalHeight?: number) => {
  if(!naturalWidth || !naturalHeight || !pcWidth) {
    return null;
  }

  if (naturalHeight <= PC_THRESHOLD_HEIGHT) {
    if (naturalWidth <= pcWidth) {
      return { imgWidth: naturalWidth, imgHeight: naturalHeight };
    } else {
      const scale = pcWidth / naturalWidth;
      return { imgWidth: pcWidth, imgHeight: naturalHeight * scale };
    }
  }

  if (naturalHeight > PC_THRESHOLD_HEIGHT) {
    const heightScale = PC_THRESHOLD_HEIGHT / naturalHeight;
    if (naturalWidth <= pcWidth) {
      return { imgWidth: naturalWidth * heightScale, imgHeight: PC_THRESHOLD_HEIGHT };
    } else {
      const widthScale = pcWidth / naturalWidth;
      const scale = Math.min(widthScale, heightScale);
      return { imgWidth: naturalWidth * scale, imgHeight: naturalHeight * scale };
    }
  }
};

export const calculateMImageSize = (mWidth: number, naturalWidth?: number, naturalHeight?: number) => {
  if (!naturalWidth || !naturalHeight || !mWidth) {
    return null;
  }

  const M_THRESHOLD_HEIGHT = mWidth * M_THRESHOLD_RATIO;
  if (naturalHeight <= M_THRESHOLD_HEIGHT) {
    if (naturalWidth <= mWidth) {
      return { imgWidth: naturalWidth, imgHeight: naturalHeight };
    } else {
      const scale = mWidth / naturalWidth;
      return { imgWidth: mWidth, imgHeight: naturalHeight * scale };
    }
  }

  if (naturalHeight > M_THRESHOLD_HEIGHT) {
    const heightScale = M_THRESHOLD_HEIGHT / naturalHeight;
    if (naturalWidth <= mWidth) {
      return { imgWidth: naturalWidth * heightScale, imgHeight: M_THRESHOLD_HEIGHT };
    } else {
      const widthScale = mWidth / naturalWidth;
      const scale = Math.min(widthScale, heightScale);
      return { imgWidth: naturalWidth * scale, imgHeight: naturalHeight * scale };
    }
  }
};

export const checkImageResourceStatus = (url: string, callback: (statusCode: number) => void) => {
  if (!url) {
    return;
  }

  const xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.responseType = 'blob';
  xhr.onload = function() {
    if (xhr.status === 403 || xhr.status === 404) {
      callback(xhr.status)
    } else if (xhr.status === 200) {
      callback(ImageResourceStatus.success);
    } else {
      callback(ImageResourceStatus.unknown);
    }
  };
  xhr.onerror = function() {
    callback(ImageResourceStatus.notFound);
  };
  xhr.send();
};

export enum ImageResourceStatus {
  /** 本地图片 */
  local = 'local',
  /** 审核中/审核失败 */
  audit = 403,
  /** 图片未找到 */
  notFound = 404,
  /** 成功 */
  success = 200,
  /** 未知错误 */
  unknown = 500,
}
